export const formatPrice = (value) => {
  const amount = Number(value);
  if (!Number.isFinite(amount)) return "—";
  return `₹${amount.toLocaleString("en-IN")}`;
};

export const getFinalAmount = (amount, discount = 0) => {
  const total = Number(amount);
  const off = Number(discount || 0);
  if (!Number.isFinite(total)) return null;
  return Math.max(0, total - (Number.isFinite(off) ? off : 0));
};

export const getDiscountPercent = (amount, discount) => {
  const total = Number(amount);
  const off = Number(discount);
  if (!Number.isFinite(total) || total <= 0 || !Number.isFinite(off) || off <= 0) {
    return null;
  }
  return `${Math.round((off / total) * 100)}% off`;
};

export const hasPackageDiscount = (amount, discount) => {
  const finalAmount = getFinalAmount(amount, discount);
  const total = Number(amount);
  return Number.isFinite(finalAmount) && Number.isFinite(total) && total > 0 && finalAmount < total;
};

export const hasBookDiscount = (price, discountedPrice) => {
  const total = Number(price);
  const final = Number(discountedPrice);
  return Number.isFinite(total) && Number.isFinite(final) && final > 0 && final < total;
};

export const getBookDiscountPercent = (price, discountedPrice) => {
  const total = Number(price);
  const final = Number(discountedPrice);
  if (!Number.isFinite(total) || total <= 0 || !Number.isFinite(final) || final >= total) {
    return null;
  }
  return `${Math.round(((total - final) / total) * 100)}% off`;
};
